import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FichaXInstancia } from 'src/app/models/FichaXInstancia';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
import { Entidad } from 'src/app/models/Entidad';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ModalEmpresaComponent } from '../../empresa/modal-involucrada/modal-empresa/modal-empresa.component';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { Catalogo } from 'src/app/models/Catalogo';
import { openModalMensaje, ConvertDateTimeToStrForBD, anioActualGlobal, stringFechaMaxima, ngClassAceptarModal, ngClassSalirModal, isEmpty, dscEtiquetaBtnSalirModal, dscEtiquetaBtnAcepModal, NumIdCatTipoInstOci, NumIdCatTipoInstAdm, ConvertStrDateToFormatBD, ConvertStringDateStr, NumAnhoMinRegistro, StrDscToolTipText, recupToolTipCar, limpiarTexto } from 'src/app/general/variables';
import { NavModalComponent } from 'src/app/pages/General/nav-modal/nav-modal.component';
import { ValidarFechaLength } from 'src/app/general/Funciones';

@Component({
  selector: 'app-modal-instancia',
  templateUrl: './modal-instancia.component.html',
  styleUrls: ['./modal-instancia.component.css']
})
export class ModalInstanciaComponent implements OnInit {

  instancia: FichaXInstancia  = new FichaXInstancia();
  listEntidadesObras: Entidad[] = [];
  listEstado: Catalogo[] = [];
  nombreEntidad = '';
  fechaMaxima: string = stringFechaMaxima;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  fechaPresentacion = '';
  strDscTooltip: string = StrDscToolTipText;
  // ValidarFechaLength = ValidarFechaLength;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private entidadService: EntidadService,
              public dialogRef: MatDialogRef<ModalEmpresaComponent>, @Inject(MAT_DIALOG_DATA)
              public data: any, private dialog: MatDialog,
              private catalogoService: CatalogoService) { }



  ngOnInit() {

    this.instancia.estado.ncatalogoId = null;

    // this.instancia.cfichaxinstanCodtipoinst = ;

    this.navModalC.setDatosNavModal2('Registrar datos del documento presentado');

    this.catalogoService.listarCatalogo(21).subscribe(data => {
      this.listEstado = data;
    });

    if (this.data.modificar) {

      this.instancia = this.data.instancia;
      this.data.listaInstancia.splice(this.data.indexModif, 1);

      this.fechaPresentacion = ConvertStringDateStr(this.instancia.strDfichaxinstanFechaprest, 1);

    }

  }
  _cambioTexto() {
    this.strDscTooltip = recupToolTipCar(this.instancia.cfichaxinstanMotivo);
  }

  _reemplazarTexto(e) {
      const cleaned = limpiarTexto(e.target.value);
      e.target.value = cleaned;
      this.instancia.cfichaxinstanMotivo = cleaned;

     }


  _cambioFechaPresent() {

    this.fechaPresentacion = ValidarFechaLength(this.fechaPresentacion);



  }

  obtenerEstado(idCatalogo: number) {

    // console.log(idCatalogo);

      this.listEstado.forEach(cat => {

          if (cat.ncatalogoId == idCatalogo) {
            this.instancia.estado = cat;

          }
      });
  }
  buscarEntidad(valor) {
    // console.log(valor);
    const nombreEntidad = valor.target.value;
    this.instancia.entidad.centNombre = nombreEntidad;

    if (valor.target.value.length > 3) {

      // console.log("=====1",valor.target.value);

      this.entidadService.obtenerEntidadesXNombre(nombreEntidad).subscribe(data => {

          data = data.slice( 0, 20 );

          // console.log("=====2",data, data.length);
          this.listEntidadesObras = data;

          if (this.listEntidadesObras.length == 1) {

            // this.obtenerEntidad(this.entidades[0].centCodigo);

            // console.log("=====3",this.listEntidadesObras[0].centNombre);

            this.llenarCombosEntidad(this.listEntidadesObras[0].centNombre);

          }

          // console.log("==============this.listEntidadesObras");
          // console.log(this.listEntidadesObras);

      });
    }
  }

  seleccionarEntidad(event) {

    let name = event.target.value;
    //const name = strEntidad;


    this.llenarCombosEntidad(name);

    this.listEntidadesObras = [];

  }

  _asignarCodTipoEnt(tipoInst) {
    console.log(tipoInst);
    //const tipoInst = event.toElement.value;

    this.instancia.cfichaxinstanCodtipoinst = tipoInst;
    this.instancia.nfichaxinstanIdtipoinst = (tipoInst === 'OCI' ? NumIdCatTipoInstOci : NumIdCatTipoInstAdm) ;

    // console.log(this.instancia.cfichaxinstanCodtipoinst);

  }

  obtenerEntidad(codigo: string) {
    this.entidadService.obtenerEntidadXCodigo(codigo).subscribe(data => {
      if (data != null) {
        this.instancia.entidad.centNombre = data.centNombre;
        this.instancia.entidad.centDirdep = data.centDirdep;
        this.instancia.entidad.centDirpro = data.centDirpro;
        this.instancia.entidad.centDirdis = data.centDirdis;
        this.instancia.entidad.centDirecc = data.centDirecc;
        this.instancia.entidad.centCodigo = data.centCodigo;
      }

     });
  }

 llenarCombosEntidad(nombreEntidad: string) {

    // let list = null;

   /** if (this.listEntidadesObras) {

      list = this.listEntidadesObras.filter(x => x.centNombre === nombreEntidad)[0];

    }*/


    /**if (list != null) {
      this.nombreEntidad = list.centNombre;
      this.entidadService.obtenerEntidadXCodigo(list.centCodigo).subscribe(data => {
        this.instancia.entidad = data;
      });
    }*/
    console.log(nombreEntidad);
    let data = new Entidad();
    data.centNombre = nombreEntidad;
    this.instancia.entidad = data;

  }

  agregarInstancia() {

    let valido = true;
    const fechaValidar = null;
    const vIndexInst = 0;
    const fechaPrest: string = this.fechaPresentacion;
    const dateFechaPrest: Date = new Date(fechaPrest);
    let fechaActual = new Date();
    let dateFechaValPrest: Date = new Date(fechaPrest);

    // console.log("====dateFechaValPrest1");
    // console.log(dateFechaValPrest);

    dateFechaValPrest.setDate(dateFechaValPrest.getDate() + 1);

    // console.log("====dateFechaValPrest2");
    // console.log(dateFechaValPrest);

    dateFechaValPrest = new Date(dateFechaValPrest.getFullYear(), dateFechaValPrest.getMonth(), dateFechaValPrest.getDate());
    fechaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate());

    this.instancia.dfichaxinstanFchPresent = dateFechaPrest;
    this.instancia.strDfichaxinstanFechaprest = ConvertStrDateToFormatBD(fechaPrest);

    this.obtenerEstado(this.instancia.estado.ncatalogoId);


    if (dateFechaPrest.getFullYear() < NumAnhoMinRegistro) {

      openModalMensaje('Instancia', 'La fecha de presentación es inválida, por favor verifique.', this.dialog);

      return;

    }
    console.log(this.instancia.entidad.centNombre);
    if (isEmpty(this.instancia.entidad.centNombre)) {

        openModalMensaje('Instancia', 'Ingresa la entidad, por favor verifique.', this.dialog);

        return;

    }

    // console.log("===fechaActual < dateFechaValPrest");
    // console.log(fechaActual);
    // console.log(dateFechaValPrest);

    if (fechaActual < dateFechaValPrest) {

      openModalMensaje('Instancia', 'La fecha de presentación no debe ser mayor a la fecha actual, por favor verifique.', this.dialog);

      return;

    }

    // console.log("=====this.data.listaInstancia");
    // console.log(this.data.listaInstancia);

    this.data.listaInstancia.forEach(instanciaV => {

      if (instanciaV.entidad.centCodigo == this.instancia.entidad.centCodigo
        && instanciaV.estado.ncatalogoId == this.instancia.estado.ncatalogoId) {

        openModalMensaje('Instancia', 'Ya se encuentra registrada esta instancia.', this.dialog);

        valido = false;

        return;

      }

    });

    // fechaValidar = new Date(this.instancia.dfichaxinstanFchPresent);

    // if(fechaValidar.getFullYear() > anioActualGlobal)
    // {

    //   openModalMensaje('Instancia','El año no puede ser mayor al año actual.',this.dialog);

    // }

    if (valido) {

      // vIndexInst = ;

      // if(vIndexInst > 0 )
      // {



      // }

      this.instancia.cfichaxinstanCodtipo = 'FUR';
      this.instancia.cfichaxinstanCodent = this.instancia.entidad.centCodigo;
      this.instancia.nfichaxinstanIdestado = this.instancia.estado.ncatalogoId;

      // console.log("============this.instancia");
      // console.log(this.instancia);

      this.data.listaInstancia.push(this.instancia);
      this.dialogRef.close(this.data);

    }

  }

  cancelar() {
    this.dialogRef.close(null);
  }

}
